import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import * as PrimitiveAccordion from '@radix-ui/react-accordion';
import twMerge from '../../utils/twMerge';
import { classNames } from 'utils/src/classnames';
import { Item } from './item';

export { default as Loader } from './loader';
export { Header } from './header';
export { Content } from './content';
export { Item };

const StyledRoot = styled(PrimitiveAccordion.Root)`
  ${tw`flex flex-col`}
`;

type Props = (PrimitiveAccordion.AccordionSingleProps | PrimitiveAccordion.AccordionMultipleProps) & {
  children: React.ReactNode;
  type: 'single' | 'multiple';
  value?: string | string[];
  defaultValue?: string | string[];
  onValueChange?: (value: string | string[]) => void;
  disabled?: boolean;
  collapsible?: boolean;
  className?: string;
};

export const Root = ({
  children,
  type,
  value,
  defaultValue,
  onValueChange,
  disabled = false,
  collapsible = false,
  className,
  ...props
}: Props): JSX.Element => (
  // @ts-expect-error Ignore me
  <StyledRoot
    {...props}
    disabled={disabled}
    value={value}
    defaultValue={defaultValue}
    onValueChange={onValueChange}
    type={type}
    collapsible={collapsible || undefined}
    className={twMerge(classNames(['gap-3', className ?? '']))}
  >
    {children}
  </StyledRoot>
);
